/**
 * Safely open a new window (and set opener to null due to XSS)
 * https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
 * @param url
 */
export const safelyOpenwindow = (url: string) => {
    window.open(url, '_blank', 'noopener noreferrer')
}

// sized for payment windows
export const openPopupWindow = (url: string, name: string) => {
    window.open(
        url,
        name,
        'popup=yes,width=600,height=800,top=200,left=200,noopener,noreferrer',
    )
}
